import React from "react";
import PageComponent from "../PageComponent";
import Help from "./Help";
import { paths } from "../../../paths";
import { labels } from "../../../../localization/labels";
import { withRouter } from "react-router-dom";

class HelpContainer extends PageComponent {
  handleHelpShow = () => {
    this.changePath(paths.README_PATH, labels.information, { from: undefined });
  };

  getComponentTitle = () => {
    return labels.information;
  };

  render() {
    return <Help handleHelpShow={this.handleHelpShow} />;
  }
}

export default withRouter(HelpContainer);
